import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/system';
import React from 'react';

import type { StackedIconProps as IconProps } from '@constants/scan';

interface StackedIconProps {
  icons: IconProps[];
}

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(() => [{}]);

export default function StackedIcon({ icons }: StackedIconProps) {
  const {
    palette: { primary },
  } = useTheme();
  return (
    <span className="fa-layers fa-fw">
      {icons.map((icon, index) => (
        <StyledFontAwesomeIcon
          key={index}
          {...icon}
          icon={[icon.type ?? 'fad', icon.name]}
          className={icon.className ?? 'fa-stack-1x'}
          sx={{
            color: icon.color ?? primary.main,
          }}
        />
      ))}
    </span>
  );
}
